import { FC } from 'react';
import { motion } from 'framer-motion';
import { Apple, Play, Smartphone } from 'lucide-react';

export const AppDownloadButtons: FC = () => {
  return (
    <div className="relative py-16 overflow-hidden">
      {/* Background gradient blur */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-blue-950/20 dark:via-indigo-950/20 dark:to-purple-950/20 -z-10" />
      
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <div className="inline-flex items-center gap-2 bg-blue-200 dark:bg-blue-900/50 text-blue-950 dark:text-blue-50 px-4 py-2 rounded-full text-sm font-bold mb-4 border border-blue-300 dark:border-blue-700">
            <Smartphone className="w-4 h-4" />
            For Parents Only
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Download the SleepNest
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent"> Mobile App</span>
          </h2>
          
          <p className="text-lg text-gray-900 dark:text-gray-100 mb-6 max-w-2xl mx-auto font-medium">
            Get personalized sleep guidance, track your child's progress, and connect with certified sleep consultants — all from your phone.
          </p>
        </motion.div>

        {/* Download buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8"
        >
          <motion.a
            href="https://play.google.com/store/apps/details?id=sleepnest.gentlebirth.app"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.98 }}
            className="group inline-flex items-center gap-3 px-8 py-4 bg-white dark:bg-gray-800 border-2 border-gray-900 dark:border-gray-300 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 min-w-[220px]"
            aria-label="Download SleepNest app on Google Play Store"
          >
            <Play className="w-10 h-10 text-green-700 dark:text-green-400 group-hover:scale-110 transition-transform" fill="currentColor" />
            <div className="text-left">
              <div className="text-xs text-gray-900 dark:text-gray-100 uppercase font-bold tracking-wide">Get it on</div>
              <div className="text-xl font-bold text-gray-900 dark:text-white">Google Play</div>
            </div>
          </motion.a>

          <motion.a
            href="https://apps.apple.com/us/app/sleepnest-by-gb/id6751678693"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.98 }}
            className="group inline-flex items-center gap-3 px-8 py-4 bg-white dark:bg-gray-800 border-2 border-gray-900 dark:border-gray-300 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 min-w-[220px]"
            aria-label="Download SleepNest app on Apple App Store"
          >
            <Apple className="w-10 h-10 text-gray-900 dark:text-white group-hover:scale-110 transition-transform" />
            <div className="text-left">
              <div className="text-xs text-gray-900 dark:text-gray-100 uppercase font-bold tracking-wide">Download on the</div>
              <div className="text-xl font-bold text-gray-900 dark:text-white">App Store</div>
            </div>
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
};
